import settings from './Settings.json'

export default class Settings {
  public static readonly idUrl = settings.idUrl
  public static readonly adminBackend = settings.adminBackend
  public static readonly usersUrl = settings.usersUrl
  public static readonly servicesUrl = settings.servicesUrl
  public static readonly clientId = settings.clientId
}
